// extracted by mini-css-extract-plugin
export var errorPage__btn = "ErrorPage-module--errorPage__btn--e9569";
export var errorPage__btnText = "ErrorPage-module--errorPage__btnText--36d6a";
export var errorPage__btnText___contact = "ErrorPage-module--errorPage__btnText___contact--89394";
export var errorPage__btnWrapper = "ErrorPage-module--errorPage__btnWrapper--984fb";
export var errorPage__btn___contact = "ErrorPage-module--errorPage__btn___contact--a9050";
export var errorPage__hero = "ErrorPage-module--errorPage__hero--075db";
export var errorPage__subtitle = "ErrorPage-module--errorPage__subtitle--b07da";
export var errorPage__title = "ErrorPage-module--errorPage__title--2fca9";